import { combineReducers } from 'redux';
import { createGenericRequestStatusReducer, createSimpleRequestStatusReducer } from 'ContentData/helpers/reduxHelpers';
import { KNOWLEDGEBASES_FETCH_KNOWLEDGEBASE, KNOWLEDGEBASES_FETCH_KNOWLEDGEBASES, KNOWLEDGEBASES_CLEAR_KNOWLEDGEBASES_CACHE, KNOWLEDGEBASES_SAVE_KNOWLEDGEBASES_CACHE } from 'ContentData/actions/ActionTypes';
const knowledgeBasesCache = (state = {}, action) => {
  switch (action.type) {
    case KNOWLEDGEBASES_FETCH_KNOWLEDGEBASES:
      {
        const {
          response
        } = action;
        if (!response) return state;
        if (!(response && response.new)) return state;
        return response.new.reduce((hash, kb) => {
          const kbItem = kb.knowledgeBase.values;
          hash[kbItem.hs_id] = kbItem;
          return hash;
        }, Object.assign({}, state));
      }
    case KNOWLEDGEBASES_CLEAR_KNOWLEDGEBASES_CACHE:
      {
        if (Object.keys(state).length) return {};
        return state;
      }
    default:
      return state;
  }
};
const knowledgeBases = (state = {}, action) => {
  switch (action.type) {
    case KNOWLEDGEBASES_FETCH_KNOWLEDGEBASE:
      {
        const {
          response
        } = action;
        if (!response || !response.values) return state;
        return Object.assign({}, state, {
          [response.values.hs_id]: response.values
        });
      }
    case KNOWLEDGEBASES_SAVE_KNOWLEDGEBASES_CACHE:
      {
        const {
          knowledgeBase
        } = action;
        if (!knowledgeBase) return state;
        return Object.assign({}, state, {
          [knowledgeBase.hs_id]: knowledgeBase
        });
      }
    default:
      return state;
  }
};
export default combineReducers({
  knowledgeBasesCache,
  knowledgeBases,
  knowledgeBasesCacheRequestStatus: createSimpleRequestStatusReducer(KNOWLEDGEBASES_FETCH_KNOWLEDGEBASES),
  requestStatus: createGenericRequestStatusReducer(KNOWLEDGEBASES_FETCH_KNOWLEDGEBASES)
});